// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1c9am","logo":"Footer-module--logo--3Uan7","contact":"Footer-module--contact--27cin","info":"Footer-module--info--1mG7V"};